import React, { useEffect, useState } from "react";
import "./ShortcutModal.css";

export default function ShortcutModal({ shortcuts, onClose, onSave, onDelete }) {
  const [editingId, setEditingId] = useState(null);
  const [command, setCommand] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  // Quando atalhos mudam, limpar caso o que estava editando tenha sido removido
  useEffect(() => {
    if (editingId && !shortcuts.find((s) => s.id === editingId)) {
      handleNew();
    }
  }, [shortcuts, editingId]);

  function handleNew() {
    setEditingId(null);
    setCommand("");
    setTitle("");
    setMessage("");
  }

  function handleEdit(atalho) {
    setEditingId(atalho.id);
    setCommand(atalho.command || "");
    setTitle(atalho.title || "");
    setMessage(atalho.message || "");
  }

  async function handleSubmit(e) {
    e.preventDefault();
    await onSave({
      id: editingId,
      command,
      title,
      message,
    });
    handleNew();
  }

  async function handleDelete() {
    if (!editingId) return;
    if (!window.confirm("Tem certeza que deseja excluir este atalho?")) return;

    await onDelete(editingId);
    handleNew();
  }

  return (
    <div className="shortcut-modal-overlay">
      <div className="shortcut-modal">
        {/* ============================= */}
        {/* HEADER */}
        {/* ============================= */}
        <div className="shortcut-modal-header">
          <div>
            <h2 className="shortcut-modal-title">Atalhos de mensagem</h2>
            <p className="shortcut-modal-sub">
              Crie respostas salvas para usar rapidamente no chat digitando{" "}
              <code>/comando</code>.
            </p>
          </div>

          <button className="shortcut-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* ============================= */}
        {/* BODY */}
        {/* ============================= */}
        <div className="shortcut-modal-body">
          {/* ============================= */}
          {/* LISTA DE ATALHOS EXISTENTES */}
          {/* ============================= */}
          <div className="shortcut-list">
            <div className="shortcut-list-header">
              <span>Atalhos salvos</span>
              <button className="btn-new-shortcut" onClick={handleNew}>
                + Novo atalho
              </button>
            </div>

            {shortcuts.length === 0 && (
              <p className="shortcut-list-empty">
                Nenhum atalho cadastrado ainda.
              </p>
            )}

            {shortcuts.map((s) => (
              <div
                key={s.id}
                className={`shortcut-list-item ${
                  editingId === s.id ? "shortcut-list-item-active" : ""
                }`}
                onClick={() => handleEdit(s)}
              >
                <div className="shortcut-list-main">
                  <span className="shortcut-chip">/{s.command}</span>
                  <span className="shortcut-title">
                    {s.title || "Sem título"}
                  </span>
                </div>

                <p className="shortcut-preview">
                  {s.message?.length > 80
                    ? s.message.slice(0, 80) + "..."
                    : s.message}
                </p>
              </div>
            ))}
          </div>

          {/* ============================= */}
          {/* FORMULÁRIO */}
          {/* ============================= */}
          <div className="shortcut-form">
            <h3 className="shortcut-form-title">
              {editingId ? "Editar atalho" : "Novo atalho"}
            </h3>

            <form onSubmit={handleSubmit}>
              {/* COMANDO */}
              <div className="form-group">
                <label>
                  Comando
                  <span className="label-hint">sem a barra</span>
                </label>

                <div className="command-input-wrapper">
                  <span className="command-slash">/</span>
                  <input
                    type="text"
                    value={command}
                    onChange={(e) => setCommand(e.target.value)}
                    placeholder="ex: oi, boasvindas, encerramento"
                    required
                  />
                </div>
              </div>

              {/* TÍTULO */}
              <div className="form-group">
                <label>Título (opcional)</label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="ex: Acolhimento inicial, Finalização gentil"
                />
              </div>

              {/* MENSAGEM */}
              <div className="form-group">
                <label>Mensagem</label>
                <textarea
                  rows={6}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Digite a mensagem que será enviada quando usar este atalho..."
                  required
                />
              </div>

              {/* BOTÕES */}
              <div className="shortcut-form-actions">

                {/* FECHAR */}
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={onClose}
                >
                  Fechar
                </button>

                {/* DELETAR */}
                {editingId && (
                  <button
                    type="button"
                    className="btn-delete"
                    onClick={handleDelete}
                  >
                    Excluir
                  </button>
                )}

                {/* SALVAR */}
                <button type="submit" className="btn-save">
                  {editingId ? "Salvar alterações" : "Criar atalho"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
